import React, { Fragment } from "react";
import { userContext } from "./FormComponent";
import { useContext } from "react";

export const Labels = (props) => {
  const {
    texto,
    numero,
    required,
    preguntaId,
    preguntaHija,
    textoEnriquecido,
  } = props;
  const { enumera } = useContext(userContext);
  
  return (
    <>
      {textoEnriquecido ? (
        <p className="texto-enriquecido-container">
          <span
            className="questions"
            id={preguntaId}
            dangerouslySetInnerHTML={{ __html: textoEnriquecido }}
          />
          {/* {Number(required) === 1 ? <i className="asterisk">*</i> : ""} */}
        </p>
      ) : enumera ? (
        !preguntaHija ? (
          <p className="questions" id={preguntaId}>
            <span className="nro-pregunta">{numero}</span>{numero ? "." : ""} {texto}{" "}
            {Number(required) === 1 ? <i className="asterisk">*</i> : ""}
          </p>
        ) : (
          <p className="questions" id={preguntaId}>
            {texto}{" "}
            {Number(required) === 1 ? <i className="asterisk">*</i> : ""}
          </p>
        )
      ) : (
        <p className="questions" id={preguntaId}>
          {texto} {Number(required) === 1 ? <i className="asterisk">*</i> : ""}
        </p>
      )}
    </>
  );
};
